import {
  GET_EVOLUTION_MEASURE_WATCHER,
  GET_EVOLUTION_MEASURE_SUCCESS,
  GET_EVOLUTION_MEASURE_FAILED,
} from "./constants"

export function getEvolutionMeasureWatcher(payload) {
  return { type: GET_EVOLUTION_MEASURE_WATCHER, payload }
}

export function getEvolutionMeasureSuccess(payload) {
  return { type: GET_EVOLUTION_MEASURE_SUCCESS, payload }
}

export function getEvolutionMeasureFailed() {
  return { type: GET_EVOLUTION_MEASURE_FAILED }
}
